import { reduxForm } from 'redux-form'
import { withRouter } from 'react-router'

import SignUpPersonalComponent from '../components/login/SignUp/SignUpPersonalComponent'
import { getValidationRules } from '../validation/validation'
import SIGN_UP_RULES from '../validation/validationRules/signUp'
import { COMPANY_SIZES, COUNTRIES, INDUSTRIES } from '../constants/companyConstants'

export default withRouter(reduxForm({
    form: 'signUp',
    validate: getValidationRules([
        'email',
        'password',
        'confirmPassword',
        'firstName',
        'lastName',
    ], Object.assign(SIGN_UP_RULES)),
    initialValues: {
        email: '',
        firstName: '',
        lastName: '',
        companySize: COMPANY_SIZES[0],
        industry: INDUSTRIES[0],
        country: COUNTRIES[0],
    },
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(SignUpPersonalComponent));



// WEBPACK FOOTER //
// ./src/containers/SignUpPersonalContainer.js